import { type FC, memo } from 'react';
import StandardJackpot from '../../StandardJackpot';
import type { StandardJackpotProps } from '../../../types/jackpot.types';
import styles from './HighCash.module.css';

const HighCashJackpot: FC<StandardJackpotProps> = (props) => {
  const highCashIcons = {
    panel: '/group_high_cash/logo',
    grand: '/group_high_cash/grand',
    major: '/group_high_cash/major',
    minor: '/group_high_cash/minor',
    mini: '/group_high_cash/mini',
  };

  return (
    <StandardJackpot
      {...props}
      icons={highCashIcons}
      className={styles.highCashTheme}
    />
  );
};

export default memo(HighCashJackpot);
